module.exports = __webpack_public_path__ + "img/jsj.2e793b35.png";